export default "__VITE_ASSET__CbVm8T5N__"